// Generated by genversion.
export const version = '12.5.0'
